import { RequestMainService } from "../request";

export class LanguageService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/langs`, params).then(
      ({ result }) => {
        return {
          count: result?.total,
          data: result.langs,
        };
      }
    );
  }
}
